"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerLocationHandler = void 0;
const React = require("react");
const react_1 = require("react");
const context_1 = require("./context");
const useSetCustomerLocation_1 = require("../../hooks/useSetCustomerLocation");
const useRetrieveCustomerLocation_1 = require("../../hooks/useRetrieveCustomerLocation");
const usePreviousValue_1 = require("../../../../../hooks/usePreviousValue");
const CustomerLocationHandler = ({ currentCustomerLocation, children }) => {
    const [customerLocation, setCustomerLocation] = (0, react_1.useState)(currentCustomerLocation);
    const [completedInitialLocationRetrieval, setCompletedInitialLocationRetrieval] = (0, react_1.useState)(!!currentCustomerLocation);
    const previousCurrentLocation = (0, usePreviousValue_1.usePreviousValue)(customerLocation);
    (0, react_1.useEffect)(() => {
        if (currentCustomerLocation) {
            return;
        }
        _retrieveCustomerLocation().then(location => {
            if (!location) {
                setCustomerLocation(null);
                return;
            }
            const decodedLocation = atob(location);
            const parsedLocation = JSON.parse(decodedLocation);
            setCustomerLocation(parsedLocation);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (!completedInitialLocationRetrieval) {
            setCompletedInitialLocationRetrieval(true);
            return;
        }
        if (previousCurrentLocation === currentCustomerLocation) {
            return;
        }
        if (!customerLocation) {
            _setCustomerLocation(null).catch(console.error);
            return;
        }
        const base64Location = btoa(JSON.stringify(customerLocation));
        _setCustomerLocation(base64Location).catch(console.error);
    }, [
        customerLocation,
        completedInitialLocationRetrieval,
        previousCurrentLocation
    ]);
    const { mutate: _retrieveCustomerLocation, error: retrieveCustomerLocationError, isLoading: isRetrievingCustomerLocation } = (0, useRetrieveCustomerLocation_1.useRetrieveCustomerLocation)({});
    const { mutate: _setCustomerLocation, error: setCustomerLocationError, isLoading: isSettingCustomerLocation } = (0, useSetCustomerLocation_1.useSetCustomerLocation)({});
    const provider = (0, react_1.useMemo)(() => ({
        customerLocation,
        setCustomerLocation,
        retrieveCustomerLocationError,
        isRetrievingCustomerLocation,
        setCustomerLocationError,
        isSettingCustomerLocation,
        completedInitialLocationRetrieval
    }), [
        customerLocation,
        setCustomerLocation,
        retrieveCustomerLocationError,
        isRetrievingCustomerLocation,
        setCustomerLocationError,
        isSettingCustomerLocation,
        completedInitialLocationRetrieval
    ]);
    return (React.createElement(context_1.CustomerLocationContext.Provider, { value: provider }, children));
};
exports.CustomerLocationHandler = CustomerLocationHandler;
//# sourceMappingURL=index.js.map